import './EventsPage.css';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import multiMonthPlugin from '@fullcalendar/multimonth';
import bootstrap5Plugin from '@fullcalendar/bootstrap5';
import React, { useState, useEffect } from 'react';
import { EventInput, EventClickArg } from '@fullcalendar/core';
import { EventImpl } from '@fullcalendar/core/internal';
import EventModal from '../components/EventsPage/EventModal';
import { getEventRange, isEventOver } from '../components/Utils/EventUtil';
import { parse } from 'date-fns';
import Table from 'react-bootstrap/Table';
import Form from 'react-bootstrap/Form';

function EventsPage() {
  const [events, setEvents] = useState<EventInput>([]);
  const [selectedEvent, selectEvent] = useState<EventImpl>();
  const [showPastEvents, setShowPastEvents] = useState<boolean>(false);

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    var eventData = [
      {
        title: 'Training',
        description: 'Treffpunkt ist 14:45 Uhr vor dem Eingang zum Hallenbad.',
        contactPerson: 'Max Reinhardt, Frederik Haak',
        location: 'Rebmeerbad, Friedrich-Ebert-Straße 40, 76887 Bad Bergzabern',
        start: '2026-01-10T14:45:00',
        end: '2026-01-10T16:45:00',
        allDay: false,
        backgroundColor: '#0082cb',
      },
      {
        title: 'Training',
        description: 'Treffpunkt ist 14:45 Uhr vor dem Eingang zum Hallenbad.',
        contactPerson: 'Max Reinhardt, Frederik Haak',
        location: 'Rebmeerbad, Friedrich-Ebert-Straße 40, 76887 Bad Bergzabern',
        start: '2026-01-24T14:45:00',
        end: '2026-01-24T16:45:00',
        allDay: false,
        backgroundColor: '#0082cb',
      },
      {
        title: 'Training',
        description: 'Treffpunkt ist 14:45 Uhr vor dem Eingang zum Hallenbad.',
        contactPerson: 'Max Reinhardt, Frederik Haak',
        location: 'Rebmeerbad, Friedrich-Ebert-Straße 40, 76887 Bad Bergzabern',
        start: '2026-02-07T14:45:00',
        end: '2026-02-07T16:45:00',
        allDay: false,
        backgroundColor: '#0082cb',
      },
      {
        title: 'Training',
        description: 'Treffpunkt ist 14:45 Uhr vor dem Eingang zum Hallenbad.',
        contactPerson: 'Max Reinhardt, Frederik Haak',
        location: 'Rebmeerbad, Friedrich-Ebert-Straße 40, 76887 Bad Bergzabern',
        start: '2026-02-21T14:45:00',
        end: '2026-02-21T16:45:00',
        allDay: false,
        backgroundColor: '#0082cb',
      },
      {
        title: 'Training',
        description: 'Treffpunkt ist 14:45 Uhr vor dem Eingang zum Hallenbad.',
        contactPerson: 'Max Reinhardt, Frederik Haak',
        location: 'Rebmeerbad, Friedrich-Ebert-Straße 40, 76887 Bad Bergzabern',
        start: '2026-03-07T14:45:00',
        end: '2026-03-07T16:45:00',
        allDay: false,
        backgroundColor: '#0082cb',
      },
      {
        title: 'Training',
        description: 'Treffpunkt ist 14:45 Uhr vor dem Eingang zum Hallenbad.',
        contactPerson: 'Max Reinhardt, Frederik Haak',
        location: 'Rebmeerbad, Friedrich-Ebert-Straße 40, 76887 Bad Bergzabern',
        start: '2026-03-21T14:45:00',
        end: '2026-03-21T16:45:00',
        allDay: false,
        backgroundColor: '#0082cb',
      },
      {
        title: 'Training',
        description: 'Treffpunkt ist 14:45 Uhr vor dem Eingang zum Hallenbad.',
        contactPerson: 'Max Reinhardt, Frederik Haak',
        location: 'Rebmeerbad, Friedrich-Ebert-Straße 40, 76887 Bad Bergzabern',
        start: '2026-04-04T14:45:00',
        end: '2026-04-04T16:45:00',
        allDay: false,
        backgroundColor: '#0082cb',
      },
      {
        title: 'Freundschaftsfahrt der Verbände PKV, KVRH, KVBW und SKB',
        description:
          'Dieses Jahr richtet die Freundschaftsfahrt der Pfälzische Kanu Verband aus. Organisierender Verein ist die Paddlergilde Ludwigshafen. Wir möchten ein attraktives und aktives Wochenende bei der PGL anbieten! Der Verein organisiert geführte Kanutouren und weitere gemeinsame Aktivitäten im Wasser und an Land, leckere Verpflegung und mit sicherlich jeder Menge Spaß: Sowohl sportlich, gesellig und für alle, die Bewegung und Gemeinschaft lieben. Lasst EUCH überraschen. Genauere Informationen und Anmeldeformular senden wir im Frühjahr an euch. Wir hoffen auf viele Anmeldungen von JUNG und ALT, welche die Veranstaltung beleben und mittragen.',
        contactPerson: 'Silvia Adolff (wanderwart@pgluhafen.de)',
        location: 'Bootshaus, Großwiesenstr. 3, 67065 Ludwigshafen',
        start: '2026-08-28',
        end: '2026-08-31',
        allDay: true,
        backgroundColor: '#f1ab2a',
        borderColor: '#e79807',
        textColor: '#000',
      },
      {
        title: 'Aufräumaktion im Bootshaus',
        description:
          'Jährliche Aufräumaktion im Bootshaus, um unser Material zu prüfen, zu reparieren und wieder fit für die kommende Paddelsaison zu machen. Zudem möchten wir im und um das Bootshaus wieder klar Schiff machen.',
        contactPerson: 'Max Reinhardt',
        location: 'Bootshaus, Auf dem Viertel 11, 76887 Bad Bergzabern',
        start: '2026-03-14T10:00:00',
        end: '2026-03-14T17:00:00',
        allDay: false,
        backgroundColor: '#c92115',
      },
      {
        title: 'Wildwasserausfahrt nach Georgien mit LiLi (Love it live it)',
        description:
          'Wildwasserausfahrt nach Georgien mit LiLi (Love it live it), Kosten ca. 1200€ exklusive Anreise, Frederik ist dabei und würde sich über weiter Mitpaddler aus dem Verein freuen. Für mehr Informationen siehe (https://loveitliveit.co.uk/whitewater-kayaking-holidays-trips/georgia-spring-creeking-in-the-caucasus-mountains/)',
        location: 'Georgien',
        contactPerson: 'Frederik Haak',
        start: '2026-04-26',
        end: '2026-05-03',
        allDay: true,
        backgroundColor: '#f1ab2a',
        borderColor: '#e79807',
        textColor: '#000',
      },
      {
        title: 'Osterfahrt an die Ardèche',
        description:
          'Osterfahrt an Ardèche und Beaume – geeignet für Anfänger und Fortgeschrittene im Kanusport sowie für alle, die die französische "douceur de vivre" zwischen Fluss, Fels und Frühlingssonne genießen möchten. Das Highlight ist das Paddeln durch die Schlucht der Ardèche, wo sich der Fluss tief durch die Felsen gegraben hat und hinter jeder Biegung neue, eindrucksvolle Ausblicke warten.',
        location:
          'Domaine Arleblanc Camping, 2720 route de la Charve, 07260 Rosieres',
        contactPerson: 'Susi Dueborgdioe',
        start: '2026-03-28',
        end: '2026-04-13',
        allDay: true,
        backgroundColor: '#0082cb',
      },
      {
        title: 'Aktionstag mit der Lebenshilfe und dem Kinderheim',
        //description: '',
        contactPerson: 'Susi Dueborgdioe',
        location: 'Neuburg am See',
        start: '2026-08-22',
        end: '2026-08-23',
        allDay: true,
        backgroundColor: '#0082cb',
      },
      {
        title: 'Familienwanderfahrt',
        description: 'Familienfreundliches Wanderpaddeln',
        contactPerson: 'Helmut Baaden',
        location: 'Nach Ansage',
        start: '2026-06-04',
        end: '2026-06-08',
        allDay: true,
        backgroundColor: '#0082cb',
      },
      {
        title: 'Gepäckfahrt auf dem Ornain',
        //description: '',
        contactPerson: 'Andre Kolbinger',
        location: 'Ornain (Frankreich)',
        start: '2026-05-14',
        end: '2026-05-18',
        allDay: true,
        backgroundColor: '#0082cb',
      },
      {
        title: 'Wieslauterreinigung (Anfang Oktober, genauer Termin folgt)',
        description:
          'Um die Flussperle der Südpfalz, die Wieslauter, zu erhalten möchten wir wie jedes Fahr vom Wasser aus Müll und Unrat einsammeln.',
        contactPerson: 'Helmut Baaden',
        location: 'Wieslauterreinigung',
        start: '2026-10-01',
        end: '2026-10-02',
        allDay: true,
        backgroundColor: '#0082cb',
      },
      {
        title: 'Hüningen',
        description:
          'Traningsfahrt an den Wildwasserkanal in Huningue (Parc des Eaux Vives), 09:00 Uhr Treffen am Bootshaus.',
        contactPerson: 'Max Reinhardt',
        location: 'Huningue (Frankreich)',
        start: '2026-07-26',
        end: '2026-07-26',
        allDay: true,
        backgroundColor: '#0082cb',
      },
      {
        title: 'Kajakcross für alle am Augsburger Eiskanal',
        description:
          'https://www.kanu-schwaben-augsburg.de/news-details-kanu-schwaben-augsburg/2025-boot-und-spiele-in-augsburg-am-17-mai.html',
        contactPerson: 'Lilian Hirschman',
        location: 'Eiskanal, Augsburg',
        start: '2026-05-17',
        end: '2026-05-18',
        allDay: true,
        backgroundColor: '#f1ab2a',
        borderColor: '#e79807',
        textColor: '#000',
      },
      {
        title: 'Test-Event für Wildwasserboote am Eiskanal in Augsburg',
        description:
          'Persönliche Schutzausrüstung (Paddelbekleidung, Helm, Spritzdecke, Paddel) ist selbst mitzubringen. Der Test richtet sich an erfahrene Paddler mit Wildwassererfahrung.',
        contactPerson: 'Lilian Hirschman',
        location: 'Eiskanal, Augsburg',
        start: '2026-05-10T10:00:00',
        end: '2026-05-10T17:00:00',
        allDay: false,
        backgroundColor: '#f1ab2a',
        borderColor: '#e79807',
        textColor: '#000',
      },
      {
        title: 'Kindertag Bad Bergzabern',
        description:
          'Am Kindertag der Stadt Bad Bergzabern laden wir Kinder und Jugendliche ein, den Kanusport und unseren Verein bei lustigen Spielen und spannenden Mitmachaktionen rund ums Paddeln kennenzulernen.',
        contactPerson: 'Max Reinhardt, Frederik Haak',
        location: 'Bad Bergzabern',
        start: '2026-08-09T12:00:00',
        end: '2026-08-09T17:00:00',
        allDay: false,
        backgroundColor: '#0082cb',
      },
      {
        title: 'Saisionabschluss (Grillen)',
        description:
          'Wir möchten nach dem ersten Hallenbadtraining mit euch am Bootshaus zum Saisonabschluss grillen. Baguette und Getränke sind vorhanden. Fleisch oder Grillalternativen bringt sich bitte jeder selbst mit. Salat und Kuchen/Dessert-Spenden sind willkommen. Wir freuen uns auf euch. Bitte gibt in der WhatsApp Gruppe Bescheid ob Ihr kommt, damit wir besser planen können.',
        contactPerson: 'Manuel Seibel',
        location: 'Bootshaus, Bad Bergzabern',
        start: '2026-09-19T17:00:00',
        end: '2026-09-19T22:00:00',
        allDay: false,
        backgroundColor: '#0082cb',
      },
      {
        title: 'Mitgliederversammlung',
        description:
          'Jährliche Mitgliederversammlung des Kanuverein Südliche Weinstraße e.V.',
        contactPerson: 'Manuel Seibel',
        location: 'Bootshaus, Auf dem Viertel 11, 76887 Bad Bergzabern',
        start: '2027-01-31T14:00:00',
        end: '2027-01-31T16:00:00',
        allDay: false,
        backgroundColor: '#0082cb',
      },
      {
        title: 'Fahrtenplanung 2027',
        description: 'Fahrtenplanung für das Jahr 2027.',
        contactPerson: 'Manuel Seibel',
        location: 'Bootshaus, Auf dem Viertel 11, 76887 Bad Bergzabern',
        start: '2027-01-31T16:00:00',
        end: '2027-01-31T17:00:00',
        allDay: false,
        backgroundColor: '#0082cb',
      },
      {
        title: 'Moderfahrt',
        description: '10:00 Uhr Treffen in Drusenheim am Parkplatz',
        contactPerson: 'Julian Fang (01737733622)',
        location: 'Drusenheim - Stattmatten',
        start: '2026-05-01T10:00:00',
        end: '2026-05-01T17:00:00',
        allDay: false,
        backgroundColor: '#0082cb',
      },
      {
        title: 'Wildwasserfahrt in den Alpenraum',
        description: 'Voraussichtlich Wildwasser 2-3 evtl. 4',
        contactPerson: 'Manuel Seibel',
        location: 'Noch offen',
        start: '2026-06-04',
        end: '2026-06-07',
        allDay: true,
        backgroundColor: '#0082cb',
      },
      {
        title: 'Training',
        description: 'Treffpunkt ist 19:00 Uhr vor dem Eingang zum Freibad.',
        contactPerson: 'Max Reinhardt, Frederik Haak',
        location: 'Rebmeerbad, Friedrich-Ebert-Straße 40, 76887 Bad Bergzabern',
        start: '2026-06-09T19:00:00',
        end: '2026-06-09T20:30:00',
        allDay: false,
        backgroundColor: '#0082cb',
      },
      {
        title: 'Training',
        description: 'Treffpunkt ist 19:00 Uhr vor dem Eingang zum Freibad.',
        contactPerson: 'Max Reinhardt, Frederik Haak',
        location: 'Rebmeerbad, Friedrich-Ebert-Straße 40, 76887 Bad Bergzabern',
        start: '2026-06-16T19:00:00',
        end: '2026-06-16T20:30:00',
        allDay: false,
        backgroundColor: '#0082cb',
      },
      {
        title: 'Training',
        description: 'Treffpunkt ist 19:00 Uhr vor dem Eingang zum Freibad.',
        contactPerson: 'Max Reinhardt, Frederik Haak',
        location: 'Rebmeerbad, Friedrich-Ebert-Straße 40, 76887 Bad Bergzabern',
        start: '2026-06-23T19:00:00',
        end: '2026-06-23T20:30:00',
        allDay: false,
        backgroundColor: '#0082cb',
      },
      {
        title: 'Training',
        description: 'Treffpunkt ist 19:00 Uhr vor dem Eingang zum Freibad.',
        contactPerson: 'Max Reinhardt, Frederik Haak',
        location: 'Rebmeerbad, Friedrich-Ebert-Straße 40, 76887 Bad Bergzabern',
        start: '2026-06-30T19:00:00',
        end: '2026-06-30T20:30:00',
        allDay: false,
        backgroundColor: '#0082cb',
      },
      {
        title: 'Training',
        description: 'Treffpunkt ist 19:00 Uhr vor dem Eingang zum Freibad.',
        contactPerson: 'Max Reinhardt, Frederik Haak',
        location: 'Rebmeerbad, Friedrich-Ebert-Straße 40, 76887 Bad Bergzabern',
        start: '2026-07-07T19:00:00',
        end: '2026-07-07T20:30:00',
        allDay: false,
        backgroundColor: '#0082cb',
      },
      {
        title: 'Training',
        description: 'Treffpunkt ist 19:00 Uhr vor dem Eingang zum Freibad.',
        contactPerson: 'Max Reinhardt, Frederik Haak',
        location: 'Rebmeerbad, Friedrich-Ebert-Straße 40, 76887 Bad Bergzabern',
        start: '2026-07-14T19:00:00',
        end: '2026-07-14T20:30:00',
        allDay: false,
        backgroundColor: '#0082cb',
      },
      {
        title: 'Training',
        description: 'Treffpunkt ist 19:00 Uhr vor dem Eingang zum Freibad.',
        contactPerson: 'Max Reinhardt, Frederik Haak',
        location: 'Rebmeerbad, Friedrich-Ebert-Straße 40, 76887 Bad Bergzabern',
        start: '2026-07-21T19:00:00',
        end: '2026-07-21T20:30:00',
        allDay: false,
        backgroundColor: '#0082cb',
      },
      {
        title: 'Training',
        description: 'Treffpunkt ist 19:00 Uhr vor dem Eingang zum Freibad.',
        contactPerson: 'Max Reinhardt, Frederik Haak',
        location: 'Rebmeerbad, Friedrich-Ebert-Straße 40, 76887 Bad Bergzabern',
        start: '2026-07-28T19:00:00',
        end: '2026-07-28T20:30:00',
        allDay: false,
        backgroundColor: '#0082cb',
      },
      {
        title: 'Training',
        description: 'Treffpunkt ist 19:00 Uhr vor dem Eingang zum Freibad.',
        contactPerson: 'Max Reinhardt, Frederik Haak',
        location: 'Rebmeerbad, Friedrich-Ebert-Straße 40, 76887 Bad Bergzabern',
        start: '2026-08-04T19:00:00',
        end: '2026-08-04T20:30:00',
        allDay: false,
        backgroundColor: '#0082cb',
      },
      {
        title: 'Training',
        description: 'Treffpunkt ist 19:00 Uhr vor dem Eingang zum Freibad.',
        contactPerson: 'Max Reinhardt, Frederik Haak',
        location: 'Rebmeerbad, Friedrich-Ebert-Straße 40, 76887 Bad Bergzabern',
        start: '2026-08-11T19:00:00',
        end: '2026-08-11T20:30:00',
        allDay: false,
        backgroundColor: '#0082cb',
      },
      {
        title: 'Training',
        description: 'Treffpunkt ist 19:00 Uhr vor dem Eingang zum Freibad.',
        contactPerson: 'Max Reinhardt, Frederik Haak',
        location: 'Rebmeerbad, Friedrich-Ebert-Straße 40, 76887 Bad Bergzabern',
        start: '2026-08-18T19:00:00',
        end: '2026-08-18T20:30:00',
        allDay: false,
        backgroundColor: '#0082cb',
      },
      {
        title: 'Training',
        description: 'Treffpunkt ist 19:00 Uhr vor dem Eingang zum Freibad.',
        contactPerson: 'Max Reinhardt, Frederik Haak',
        location: 'Rebmeerbad, Friedrich-Ebert-Straße 40, 76887 Bad Bergzabern',
        start: '2026-08-25T19:00:00',
        end: '2026-08-25T20:30:00',
        allDay: false,
        backgroundColor: '#0082cb',
      },
      {
        title: 'Training',
        description: 'Treffpunkt ist 19:00 Uhr vor dem Eingang zum Freibad.',
        contactPerson: 'Max Reinhardt, Frederik Haak',
        location: 'Rebmeerbad, Friedrich-Ebert-Straße 40, 76887 Bad Bergzabern',
        start: '2026-09-01T19:00:00',
        end: '2026-09-01T20:30:00',
        allDay: false,
        backgroundColor: '#0082cb',
      },
      {
        title: 'Training',
        description: 'Treffpunkt ist 14:45 Uhr vor dem Eingang zum Hallenbad.',
        contactPerson: 'Max Reinhardt, Frederik Haak',
        location: 'Rebmeerbad, Friedrich-Ebert-Straße 40, 76887 Bad Bergzabern',
        start: '2026-09-19T14:45:00',
        end: '2026-09-19T16:45:00',
        allDay: false,
        backgroundColor: '#0082cb',
      },
      {
        title: 'Training',
        description: 'Treffpunkt ist 14:45 Uhr vor dem Eingang zum Hallenbad.',
        contactPerson: 'Max Reinhardt, Frederik Haak',
        location: 'Rebmeerbad, Friedrich-Ebert-Straße 40, 76887 Bad Bergzabern',
        start: '2026-10-03T14:45:00',
        end: '2026-10-03T16:45:00',
        allDay: false,
        backgroundColor: '#0082cb',
      },
      {
        title: 'Training',
        description: 'Treffpunkt ist 14:45 Uhr vor dem Eingang zum Hallenbad.',
        contactPerson: 'Max Reinhardt, Frederik Haak',
        location: 'Rebmeerbad, Friedrich-Ebert-Straße 40, 76887 Bad Bergzabern',
        start: '2026-10-17T14:45:00',
        end: '2026-10-17T16:45:00',
        allDay: false,
        backgroundColor: '#0082cb',
      },
      {
        title: 'Training',
        description: 'Treffpunkt ist 14:45 Uhr vor dem Eingang zum Hallenbad.',
        contactPerson: 'Max Reinhardt, Frederik Haak',
        location: 'Rebmeerbad, Friedrich-Ebert-Straße 40, 76887 Bad Bergzabern',
        start: '2026-10-31T14:45:00',
        end: '2026-10-31T16:45:00',
        allDay: false,
        backgroundColor: '#0082cb',
      },
      {
        title: 'Training',
        description: 'Treffpunkt ist 14:45 Uhr vor dem Eingang zum Hallenbad.',
        contactPerson: 'Max Reinhardt, Frederik Haak',
        location: 'Rebmeerbad, Friedrich-Ebert-Straße 40, 76887 Bad Bergzabern',
        start: '2026-11-14T14:45:00',
        end: '2026-11-14T16:45:00',
        allDay: false,
        backgroundColor: '#0082cb',
      },
      {
        title: 'Training',
        description: 'Treffpunkt ist 14:45 Uhr vor dem Eingang zum Hallenbad.',
        contactPerson: 'Max Reinhardt, Frederik Haak',
        location: 'Rebmeerbad, Friedrich-Ebert-Straße 40, 76887 Bad Bergzabern',
        start: '2026-11-28T14:45:00',
        end: '2026-11-28T16:45:00',
        allDay: false,
        backgroundColor: '#0082cb',
      },
      {
        title: 'Training',
        description: 'Treffpunkt ist 14:45 Uhr vor dem Eingang zum Hallenbad.',
        contactPerson: 'Max Reinhardt, Frederik Haak',
        location: 'Rebmeerbad, Friedrich-Ebert-Straße 40, 76887 Bad Bergzabern',
        start: '2026-12-12T14:45:00',
        end: '2026-12-12T16:45:00',
        allDay: false,
        backgroundColor: '#0082cb',
      },
    ].sort((a, b) => {
      var startA = parse(
        a.start,
        a.allDay ? 'yyyy-MM-dd' : "yyyy-MM-dd'T'HH:mm:ss",
        new Date(),
      );
      var startB = parse(
        b.start,
        b.allDay ? 'yyyy-MM-dd' : "yyyy-MM-dd'T'HH:mm:ss",
        new Date(),
      );

      return startA > startB ? 1 : -1;
    });
    setEvents(eventData);
  }, []);

  function eventClickCalendar(eventClickInfo: EventClickArg) {
    showModal(eventClickInfo.event);
  }

  /*   function eventClickRow(event: any) {
    showModal(event);
  } */

  function showModal(event: any) {
    selectEvent(event);
    handleShow();
  }

  return (
    <div>
      <h2>Fahrten und Aktionen</h2>

      <FullCalendar
        plugins={[dayGridPlugin, bootstrap5Plugin, multiMonthPlugin]}
        initialView="dayGridMonth"
        themeSystem="bootstrap5"
        locale="de"
        height="auto"
        firstDay={1}
        buttonText={{
          today: 'Heute',
          month: 'Monat',
          week: 'Woche',
          day: 'Tag',
          list: 'Liste',
          year: 'Jahr',
        }}
        headerToolbar={{
          left: 'prev,next,today',
          center: 'title',
          right: 'dayGridMonth,multiMonthYear',
        }}
        eventClick={eventClickCalendar}
        events={events}
      />

      <h2>Übersicht:</h2>
      <Form className="show-past-events-checkbox">
        <Form.Check
          type="checkbox"
          id="show-past-events-checkbox"
          checked={showPastEvents}
          onChange={(value) => {
            setShowPastEvents(value.currentTarget.checked);
          }}
          label="Vergangene Veranstaltungen anzeigen"
        />
      </Form>

      <Table hover bordered responsive className="events-table">
        <tbody>
          {showPastEvents &&
            events.map((event: any) => (
              <EventTableRow
                key={event.start + event.end}
                event={event}
                showPast={true}
              ></EventTableRow>
            ))}
          {events.map((event: any) => (
            <EventTableRow
              key={event.start + event.end}
              event={event}
              showPast={false}
            ></EventTableRow>
          ))}
        </tbody>
      </Table>

      <EventModal
        show={show}
        handleClose={handleClose}
        event={selectedEvent}
      ></EventModal>
    </div>
  );

  function EventTableRow(props: EventTableRowProps) {
    const { event, showPast } = props;
    var eventsSelector = showPast
      ? !isEventOver(event.end, event.allDay)
      : isEventOver(event.end, event.allDay);

    if (eventsSelector) {
      return null;
    }
    return (
      <tr
        className={showPast ? 'past-event' : 'current-event'}
        onClick={() => {
          //eventClickRow(event);//todo: fix
        }}
      >
        <td>{getEventRange(event.start, event.end, event.allDay)}</td>
        <td>{event.title}</td>
        {event.contactPerson ? <td>{event.contactPerson}</td> : <td></td>}
      </tr>
    );
  }
}

export default EventsPage;

type EventTableRowProps = {
  event: any;
  showPast: boolean;
};
